(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["softroom-policy-links"] && !Shopify.designMode) return;
  try {
    (() => {
    function enablePreferences() {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return false;
      document.querySelectorAll('[data-cookie-preferences-item]').forEach(item => { item.hidden = false; });
      return true;
    }
    document.addEventListener('click', event => {
      const button = event.target.closest('.softroom-cookie-preferences');
      if (!button || !enablePreferences()) return;
      window.privacyBanner.showPreferences().catch(() => { button.focus(); });
    });
    if (!enablePreferences()) {
      let attempts = 0;
      const timer = setInterval(() => { if (enablePreferences() || ++attempts >= 40) clearInterval(timer); }, 250);
    }
    document.addEventListener('shopify:section:load', enablePreferences);
  })();
  } catch(e) { console.error(e); }
})();

})();
